import * as React from 'react';
function ArrowLeftIcon() {
  return (
    <svg
      width="12"
      height="20"
      viewBox="0 0 12 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0019 0.984993C10.5119 0.494993 9.72189 0.494993 9.23189 0.984993L0.921895 9.29499C0.531895 9.68499 0.531895 10.315 0.921895 10.705L9.23189 19.015C9.72189 19.505 10.5119 19.505 11.0019 19.015C11.4919 18.525 11.4919 17.735 11.0019 17.245L3.76189 9.99499L11.0119 2.74499C11.4919 2.26499 11.4919 1.46499 11.0019 0.984993Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default ArrowLeftIcon;
